import { useMemo, useState } from 'react';
import { feedList } from '../../../mocks/news';

function fmt(n: number) {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
}

const tabKeys = ['all', 'star', 'show', 'live', 'society', 'meme', 'deep'];

export default function Feed() {
  const [active, setActive] = useState('all');
  const list = useMemo(
    () => (active === 'all' ? feedList : feedList.filter((f) => f.categoryKey === active)),
    [active]
  );

  return (
    <section id="feeds" className="scroll-mt-24 py-12 md:py-16 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6">
          <div>
            <span className="text-xs font-semibold text-primary-600 tracking-widest uppercase">LATEST SCOOPS</span>
            <h2 className="mt-1 font-heading text-2xl md:text-4xl font-black text-foreground-950">猛料大厅</h2>
            <p className="mt-2 text-sm text-foreground-600 max-w-xl">
              突发大瓜第一时间跟进，滚动补充时间线与多方说法。按栏目筛选，追你最关心的那口瓜。
            </p>
          </div>
          <span className="text-xs text-foreground-400 flex items-center gap-1.5">
            <span className="inline-block w-2 h-2 rounded-full bg-primary-500 animate-pulse" aria-hidden="true" />
            编辑部实时追更中
          </span>
        </div>

        {/* 分类切换 */}
        <div className="flex items-center gap-1 overflow-x-auto pb-1 -mb-1 rounded-full bg-secondary-100/60 p-1 w-fit max-w-full mb-7">
          {tabKeys.map((k) => {
            const label =
              k === 'all' ? '全部' : feedList.find((f) => f.categoryKey === k)?.category ?? k;
            const isActive = active === k;
            return (
              <button
                key={k}
                type="button"
                onClick={() => setActive(k)}
                className={`whitespace-nowrap px-4 py-1.5 rounded-full text-sm transition cursor-pointer ${
                  isActive
                    ? 'bg-background-50 text-primary-700 font-semibold border border-background-300'
                    : 'text-secondary-800 hover:bg-secondary-100'
                }`}
              >
                {label}
              </button>
            );
          })}
        </div>

        {/* 内容卡片流 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {list.map((item) => (
            <article key={item.id} className="group cursor-pointer flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 hover:border-background-300 hover:-translate-y-1 transition">
              <div className="relative w-full h-40 md:h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {item.hot && (
                  <span className="absolute top-2.5 left-2.5 inline-flex items-center gap-1 rounded bg-primary-500 text-background-50 px-1.5 py-0.5 text-[11px] font-semibold">
                    <i className="ri-fire-fill text-xs" aria-hidden="true" /> 高热
                  </span>
                )}
                <span className="absolute top-2.5 right-2.5 rounded bg-foreground-950/70 text-background-100 px-2 py-0.5 text-[11px] backdrop-blur">
                  {item.category}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-4">
                <span className="inline-flex items-center gap-1 rounded bg-accent-50 text-accent-800 border border-accent-200 px-1.5 py-0.5 w-fit text-[11px] font-semibold mb-2">
                  <i className="ri-flashlight-fill text-xs" aria-hidden="true" /> {item.tag}
                </span>
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 transition line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.excerpt}</p>
                <div className="mt-auto pt-3.5 flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1 text-accent-700 font-medium">
                    <i className="ri-fire-line text-accent-500" aria-hidden="true" /> {fmt(item.heat)}
                  </span>
                  <span className="flex items-center gap-1"><i className="ri-time-line" aria-hidden="true" /> {item.time}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}